import React from 'react';
import styles from '../../Home.module.css';
import { CheckIcon } from '../../icons';

const FeatureBlocks = () => (
  <>
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={`${styles.feature} ${styles.featureFlip}`}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Chargeback Protection</span>
            <h2>Fraud disputes? We&apos;ve got you covered.</h2>
            <p>Friendly fraud and unauthorized-charge disputes quietly drain revenue from honest businesses. Fyntiq screens every transaction and covers eligible fraudulent disputes — so a bad actor doesn&apos;t cost you both the goods and the sale.</p>
            <ul className={styles.fList}>
              {['Coverage on eligible fraudulent disputes', 'Real-time fraud screening on every payment', 'We handle the dispute response for you', 'Keep your revenue on covered claims'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop}>
              <div><div className={styles.invLab}>DISPUTE</div><div className={styles.invNum}>#DSP-2208 · Northbeam Studio</div></div>
              <span className={styles.invStatus} style={{ background: 'var(--green-soft)', color: 'var(--green)' }}>Covered</span>
            </div>
            <div className={styles.invRow}><span>Order amount</span><span className={styles.mono}>$420.00</span></div>
            <div className={styles.invRow}><span>Dispute reason</span><span className={styles.mono}>Fraudulent</span></div>
            <div className={styles.invRow}><span>Handled by</span><span className={styles.mono}>Fyntiq</span></div>
            <div className={styles.invTotal}><span>Your liability</span><span className={styles.mono} style={{ color: 'var(--green)' }}>$0.00</span></div>
            <div className={styles.invPaynow} style={{ background: 'var(--green)' }}>Protected by Fyntiq ✓</div>
          </div>
        </div>
      </div>
    </section>

    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={styles.feature}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Invoicing</span>
            <h2>Invoices that get paid.</h2>
            <p>Create professional, branded invoices with a built-in &quot;Pay Now&quot; button. Your customers pay online in a tap, and every payment is reconciled for you.</p>
            <ul className={styles.fList}>
              {['Add your logo and brand colors', 'Automatic receipts for every processed payment', 'Saved payment methods for repeat customers', 'Create once, duplicate, and send to many'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop}>
              <div><div className={styles.invLab}>INVOICE</div><div className={styles.invNum}>#1043 · Northbeam Studio</div></div>
              <span className={styles.invStatus}>Due</span>
            </div>
            <div className={styles.invRow}><span>Brand strategy session</span><span className={styles.mono}>$1,000.00</span></div>
            <div className={styles.invRow}><span>Logo revisions (2)</span><span className={styles.mono}>$240.00</span></div>
            <div className={styles.invTotal}><span>Total</span><span className={styles.mono}>$1,240.00</span></div>
            <div className={styles.invPaynow}>Pay Now →</div>
          </div>
        </div>
      </div>
    </section>

    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={`${styles.feature} ${styles.featureFlip}`}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Recurring billing</span>
            <h2>Set it once. Get paid on schedule.</h2>
            <p>Put subscriptions and retainers on autopilot. Choose the cadence, send to one client or many, and pause or resume any time without losing the invoice.</p>
            <ul className={styles.fList}>
              {['Flexible scheduling with time-zone control', 'Turn recurring on or off without deleting', 'Send automatically to multiple recipients', 'See every invoice on a recurring schedule'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop} style={{ border: 'none', paddingBottom: 6 }}>
              <div className={styles.invNum} style={{ fontSize: 14 }}>Recurring schedules</div>
              <span className={styles.invLab}>4 ACTIVE</span>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOn}`} />
              <div style={{ flex: 1 }}><div className={styles.recName}>Monthly retainer — Acme</div><div className={styles.recMeta}>Every 1st · next May 1</div></div>
              <span className={styles.recAmt}>$2,500</span>
              <span className={styles.recToggle} />
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOn}`} />
              <div style={{ flex: 1 }}><div className={styles.recName}>Hosting — Bloom Co</div><div className={styles.recMeta}>Monthly · next Apr 28</div></div>
              <span className={styles.recAmt}>$49</span>
              <span className={styles.recToggle} />
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOff}`} />
              <div style={{ flex: 1 }}><div className={styles.recName}>Coaching — J. Reyes</div><div className={styles.recMeta}>Paused</div></div>
              <span className={styles.recAmt}>$300</span>
              <span className={`${styles.recToggle} ${styles.recToggleOff}`} />
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default FeatureBlocks;
